import { render, staticRenderFns } from "./RappelsComponent.vue?vue&type=template&id=5de98666&"
import script from "./RappelsComponent.vue?vue&type=script&lang=js&"
export * from "./RappelsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports